export default __webpack_public_path__ + "static/media/backgroudHomePhone.4e523f25.png";